<script>
    // import {flow_info, flow_stack} from './stores.js';
    import{user_data, flow_steps} from './stores.js';
    import { onMount } from "svelte";
    // import Iqtemplate from "./components/iqtemplate.svelte";
    import Dtemplate from "./components/detailedtemplate.svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    import Chipscompnent from './components/chipscompnent.svelte';

    export let chipsdata = [
        {s: false, t: "Purchase", i:"/img/House.svg", cbf:()=>{$flow_steps.current_flow = "drp"; $user_data.loantype = "Purchase";$flow_steps.current_next_loc = 2; $flow_steps.current_prev_loc = 0;}},
        {s: false, t: "Refinance", i:"/img/Refinance.svg", cbf:()=>{$flow_steps.current_flow = "drr"; $user_data.loantype = "Refinance";$flow_steps.current_next_loc = 2; $flow_steps.current_prev_loc = 0;}},
    ];

    onMount(async() => {

    });

</script>

<Dtemplate
progress_mobile_version={true}
show_icon_card={false}
>
    <Progresscomponent 
    title="First, are you purchasing or refinancing?"
    show_next_button={false}
    >
    <Chipscompnent
        bind:chipsdata={chipsdata}
    />
    </Progresscomponent>
</Dtemplate>

<style>

</style>